package com.wintermar.inspection.core.ui.theme.color.palette.accent

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val PurpleColorVariant = ColorVariant(
    n100 = Color(0xFFF3F0FF),
    n200 = Color(0xFFDFD8FD),
    n300 = Color(0xFFB8ACF6),
    n400 = Color(0xFF9F8FEF),
    n500 = Color(0xFF8F7EE7),
    n600 = Color(0xFF8270DB),
    n700 = Color(0xFF6E5DC6),
    n800 = Color(0xFF5E4DB2),
    n900 = Color(0xFF352C63),
    n1000 = Color(0xFF2B273F)
)
